import { debounce } from "~/lib/debounce";

interface IUseScroll {
	// [px]
	threshold?: number;
	timeout?: number;
	onScroll: (isBottom: boolean) => void;
}

export function useScroll({
	threshold = 150,
	timeout = 50,
	onScroll,
}: IUseScroll) {
	const scrollNode = Mapy.getComponent("layout").getScrollNode();

	function handleScroll() {
		const scrollNodeElem = Mapy.Util.isSmallResolution()
			? document.documentElement || document.getElementById("mapycz")
			: scrollNode;
		const scrollTop = scrollNodeElem.scrollTop;
		const scrollHeight = scrollNodeElem.scrollHeight;
		const clientHeight = scrollNodeElem.clientHeight;
		const isBottom = scrollTop + threshold >= scrollHeight - clientHeight;

		onScroll(isBottom);
	}

	const scrollCallback = debounce(() => {
		handleScroll();
	}, timeout);

	scrollNode.addEventListener("scroll", scrollCallback, Mapy.Util.scrollOptionsSupport() ? { passive: true } : false);
	document.addEventListener("scroll", scrollCallback, false);

	return () => {
		scrollNode.removeEventListener("scroll", scrollCallback, Mapy.Util.scrollOptionsSupport() ? { passive: true } : false);
		document.removeEventListener("scroll", scrollCallback, false);
	};
}
